import jquery from 'jquery';
import _ from 'lodash';
import { delay } from 'redux-saga';
import {
  call,
  put,
  select,
  fork,
  takeLatest
} from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import {
  LOAD_CUSTOMER,
  DL_PAGE_LOADED
} from './unserviceable';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {
  navigationRoutes,
  navigationSteps
} from '../../../navigation/navigationHelpers';
import {
  showGlobalSpinner,
  hideGlobalSpinner,
  errorPageByFlow
} from '../../../common/common';
import {
  SET_DATA,
  customerSelector
} from '../../../data/customer/customer';

// WATCHERS
export function* loadCustomerWatch() {
  yield takeLatest(LOAD_CUSTOMER, loadCustomerWorker);
}

// WORKERS
export function* loadCustomerWorker() {
  try {
    yield put(showGlobalSpinner({hideContent: true, initiator: 'localize load'}));

    const errorPage = yield select(errorPageByFlow);
    const success = yield call(dataProvider.load, [
      {state: 'auth'},
      {state: 'customer'},
      {state: 'context'}
    ], {errorPage});

    if (!success) {
      return;
    }

    yield delay(0); // HACK: Something is causing the saga not to execute on time - action fires, selector doesn't see state update

    const customer = yield select(customerSelector);

    if (!_.get(customer, 'moveToAddress.city')) {
      const encodedAddressSearch = encodeURI(`${customer.moveToAddress.streetAddress} ${customer.moveToAddress.zipCode}`);
      const bingAddressEndpoint = navigationRoutes[navigationSteps.movers.UNSERVICEABLE].endpoints.getBingData(encodedAddressSearch);

      const bingAddress = yield jqueryGenerator(function *() {
        try {
          return yield jquery.ajax({
            url: bingAddressEndpoint.url,
            dataType: "jsonp",
            jsonp: "jsonp"
          });
        } catch(e) {
          return;
        }
      });

      if (bingAddress && _.get(bingAddress, 'resourceSets[0].resources[0].address.locality')) {
        const customerWithCompleteMoveToAddress = {
          customer: {
            ...customer,
            moveToAddress: {
              ...customer.moveToAddress,
              city: _.get(bingAddress, 'resourceSets[0].resources[0].address.locality'),
              state: _.get(bingAddress, 'resourceSets[0].resources[0].address.adminDistrict')
            }
          }
        };

        yield put({
          type: SET_DATA,
          payload: customerWithCompleteMoveToAddress
        });
      }
    }

    yield put({
      type: DL_PAGE_LOADED
    });

    yield put(hideGlobalSpinner());
  } catch(e) {
    yield put(hideGlobalSpinner());
    //console.log(e, 'error');
    browserHistory.push(navigationRoutes[navigationSteps.movers.ERROR].path);
  }
}

export function jqueryGenerator(genertorFactory) {
  const generator = genertorFactory.apply(this, arguments);
  const handleResult = result => {
    if (result.done) return result.value;
    return result.value.then(function(nextResult) {
        return handleResult(generator.next(nextResult));
    }, function(error) {
      generator.throw(error);
    });
  };

  return handleResult(generator.next());
}

export default function* moversUnserviceableSagas() {
  yield [
    fork(loadCustomerWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/unserviceable/unserviceableSagas.js
 **/